import { User } from '../../types/auth'
import { UserStatusEnum } from '../../types/subscription'

export const canAccessAnalytics = (user: User | null) => {
	return ![
		UserStatusEnum.FREEMIUM_OLD,
		UserStatusEnum.PREMIUM_CANCELLED,
		UserStatusEnum.PREMIUM_IN_DEBT,
	].includes(user?.status as UserStatusEnum)
}

export const canAccessBilling = (user: User | null) => {
	return ![UserStatusEnum.FREEMIUM_OLD].includes(user?.status as UserStatusEnum)
}

export const canPerformQrActions = (user: User | null) => {
	return ![
		UserStatusEnum.FREEMIUM_OLD,
		UserStatusEnum.PREMIUM_CANCELLED,
		UserStatusEnum.PREMIUM_IN_DEBT,
	].includes(user?.status as UserStatusEnum)
}
